module.exports = __webpack_public_path__ + "img/carousel1.dc46cbd1.png";